<section class="nearby-panel">
  <div class="nearby-head">
    <mat-icon class="nearby-icon">near_me</mat-icon>
    <div class="nearby-titles">
      <h1 class="nearby-title">{{ 'nearby.title' | t }}</h1>
      <p class="nearby-intro">{{ 'nearby.intro' | t }}</p>
    </div>
  </div>

  <div class="nearby-actions">
    <button type="button" class="btn-pill btn-pill-accent" (click)="locate()" [disabled]="locating">
      <mat-icon>{{ locating ? 'hourglass_top' : 'my_location' }}</mat-icon>
      {{ (locating ? 'nearby.locating' : (hasPosition ? 'nearby.refresh' : 'nearby.useLocation')) | t }}
    </button>
    <div class="nearby-radius" role="group" [attr.aria-label]="'nearby.radius' | t">
      <span class="nearby-radius-label">{{ 'nearby.radius' | t }}</span>
      @for (km of radii; track km) {
        <button type="button" class="nearby-radius-btn" [class.active]="km === radius" [attr.aria-pressed]="km === radius"
          (click)="setRadius(km)">{{ 'nearby.km' | t: { km: km } }}</button>
      }
    </div>
  </div>

  @if (error) { <p class="nearby-error" role="alert">{{ error }}</p> }
  <p class="nearby-privacy"><mat-icon>lock</mat-icon>{{ 'nearby.privacy' | t }}</p>
</section>
